import MsisdnSearchStripper from "../utils/MsisdnSearchStripper";

export default class PasswordResetRequest {

    static toJson(phoneNumber) {

        let jsonObj = {};

        jsonObj["username"] = MsisdnSearchStripper.stripMsisdn(phoneNumber.toString());
        jsonObj["cellphone-number"] = MsisdnSearchStripper.stripMsisdn(phoneNumber.toString());

        return jsonObj;

    }

}